import { ConstraintSpudLimitDetailBase } from './base/constraint-spud-limit-detail-base';

export class ConstraintSpudLimitDetail extends ConstraintSpudLimitDetailBase { }